import React, { useState } from "react";
import MainStructure from "../components/containers/MainStructure";
import Pagination from "../components/elements/Pagination";
import { formatDate } from "../api/formatDate";
import { plansService } from "../api/plans.service";
import usePaginatedData from "../hooks/usePaginatedData";
import InformationCreditsModal from "../components/InformationCreditsModal";

function MyCredits() {
	const {
		data,
		loading,
		currentPage,
		totalPages,
		handlePageChange,
		startIndex,
		endIndex,
	} = usePaginatedData(plansService.listWallet, { limit: 10 });
	const [isOpenModal, setIsOpenModal] = useState(false);

	return (
		<MainStructure>
			<h1 className="center pt-10 pb-60">
				My Credits{" "}
				<i
					className="fas fa-question-circle cursor help-icon huge-medium ml-5 mt-20"
					onClick={() => setIsOpenModal(true)}
				></i>
			</h1>
			{loading ? (
				<div className="center">
					<p>Loading...</p>
				</div>
			) : data.results.length > 0 ? (
				<>
					<div className="pagination-container" style={{ marginBottom: "1rem" }}>
						<div>
							{startIndex} - {endIndex} of {data.count} Records
						</div>
						<Pagination
							currentPage={currentPage}
							totalPages={totalPages}
							onPageChange={handlePageChange}
						/>
					</div>
					<table className="transactions-table">
						<thead>
							<tr>
								<th className="col-20per">Plan</th>
								<th className="col-60per">Balance</th>
								<th className="col-20per">Expires At</th>
							</tr>
						</thead>
						<tbody>
							{data.results.map((credit) => (
								<tr key={credit.id}>
									<td className="col-20per">
										{credit.plan?.name || "N/A"}
									</td>
									<td className="col-60per">
										{credit.balance}
									</td>
									<td className="col-20per">
										{formatDate(credit.expires_at)}
									</td>
								</tr>
							))}
						</tbody>
					</table>
					<div className="pagination-container">
						<div>
							{startIndex} - {endIndex} of {data.count} Records
						</div>
						<Pagination
							currentPage={currentPage}
							totalPages={totalPages}
							onPageChange={handlePageChange}
						/>
					</div>
				</>
			) : (
				<div className="center">
					<p>There are no items</p>
				</div>
			)}
			<InformationCreditsModal
				isOpenModal={isOpenModal}
				setIsOpenModal={setIsOpenModal}
			/>
		</MainStructure>
	);
}

export default MyCredits;
